import { RightCircleFilled } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { Store } from 'antd/lib/form/interface';
import { ValidateErrorEntity } from 'rc-field-form/lib/interface';
import React, { useContext, useEffect, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import AuthWrapper from 'components/base/AuthWrapper';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import { ICaptcha } from 'services/captcha';
import restoreApi from 'services/restore';

import { emailValidation } from 'utils/validations/emailValidation';

import { callCaptcha } from './Registrace';

interface IRegistrace {}

const ZadostObnovaHesla: React.FC<IRegistrace> = () => {
    const [form] = useForm();
    const { navigateWorkaround } = useNavigateWorkaround();
    const { language } = useContext(Context);
    const [loading, setLoading] = useState<boolean>(false);
    const [isSubmit, setSubmit] = useState<boolean>(true);
    const [errCaptcha, setErrCaptcha] = useState<string>();
    const [loadingCaptcha, setLoadingCaptcha] = useState<boolean>(false);
    const [captchaState, setCaptchaState] = useState<ICaptcha>({
        id: 0,
        image: ''
    });

    useEffect(() => {
        callCaptcha(setLoadingCaptcha, setCaptchaState, setErrCaptcha);
    }, []);

    const onFinish = (value: Store) => {
        setLoading(true);
        restoreApi(value.email.toLowerCase(), language, captchaState.id, value.captcha)
            .then(() => {
                setSubmit(false);
            })
            .catch((err: any) => {
                err.response?.data.message === 'Nevalidni captcha.'
                    ? setErrCaptcha('CHYBA_REGISTRACE_401')
                    : setErrCaptcha('CHYBA_REGISTRACE_404');

                callCaptcha(setLoadingCaptcha, setCaptchaState, setErrCaptcha);
            })
            .finally(() => {
                setLoading(false);
            });
    };
    return (
        <AuthWrapper>
            {isSubmit ? (
                <FormWrapper
                    onFinish={onFinish}
                    onFinishFailed={(err: ValidateErrorEntity) => console.log('chyba:', err)}
                    outForm={form}
                >
                    <Title text="ZAPOMENUTE_HESLO" level={3} />
                    <TranslateText>LOGIN_OBNOVENI_HESLA_TEXT</TranslateText>
                    <InputComponent label="UZIVATELSKE_JMENO" name="email" type="email" rules={emailValidation()} />
                    <LoadingWrapper loading={loadingCaptcha}>
                        <InputComponent
                            label="OPISTE_TEXT_Z_OBRAZKU"
                            name="captcha"
                            type="text"
                            idCaptcha={captchaState.id}
                            imageCaptcha={captchaState.image}
                        />
                    </LoadingWrapper>
                    <Row className="button-row">
                        <Col>
                            <AnchorComponent link={true} onClick={() => navigateWorkaround(-1)}>
                                <ButtonComponent buttontext="ZPET" type="default" id="zpetBtnLogin" />
                            </AnchorComponent>
                        </Col>
                        <Col>
                            <ButtonComponent
                                buttontext="ODESLAT"
                                onClick={() => form.submit()}
                                icon={<RightCircleFilled />}
                                id="submitBtn"
                                loading={loading}
                                extramessage={errCaptcha}
                            />
                        </Col>
                    </Row>
                </FormWrapper>
            ) : (
                <>
                    <Row justify="center">
                        <h1>
                            <TranslateText>ZAPOMENUTE_HESLO</TranslateText>
                        </h1>
                    </Row>
                    <Row justify="center">
                        <Paragraph
                            style={{
                                paddingBottom: 24,
                                textAlign: 'center'
                            }}
                            text={'ZAPOMENUTE_HESLO_INFO'}
                        />
                    </Row>
                    <Row justify="center">
                        <ButtonComponent
                            buttontext="ZPET"
                            onClick={() => navigateWorkaround(-1)}
                            id="loginZpetBtn"
                            type="default"
                        />
                    </Row>
                </>
            )}
        </AuthWrapper>
    );
};

export default ZadostObnovaHesla;
